import * as React from "react";
export default class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.handleKeyPress = (event) => {
            if (event.key == 'Enter' && this.props.searchText) {
                this.props.Search();
            }
        };
    }
    componentDidUpdate() {
        if (this.props.toggle) {
            this.searchInput.focus();
        }
    }
    render() {
        let search = this.props.toggle ?
            React.createElement("div", { className: "search-bar animated" },
                React.createElement("span", null, "Search Liquor Connect"),
                React.createElement("div", null,
                    React.createElement("input", { placeholder: "Search by keyword or product name", value: this.props.searchText, onChange: (e) => { this.props.updateSearch(e.target.value); }, onKeyPress: this.handleKeyPress, ref: (input) => { this.searchInput = input; } }),
                    React.createElement("i", { className: "fa fa-search", onClick: () => { if (this.props.searchText) {
                            this.props.Search();
                        } } }))) : null;
        return search;
    }
}
;
//# sourceMappingURL=search-bar.js.map